import { createPresenceComponent } from '@fluentui/react-components';

export type PromptStarterMotionParams = { index: number; numberOfColumns: number };

export const PromptStarterMotion: ReturnType<typeof createPresenceComponent<PromptStarterMotionParams>> =
  createPresenceComponent<PromptStarterMotionParams>(({ index, numberOfColumns }) => {
    const isFirstRow = index < numberOfColumns;
    const delay = isFirstRow ? index * 50 : (index - numberOfColumns) * 50;

    const opacityDuration = 100;
    const opacityOffset = delay / (delay + opacityDuration);
    const opacityEasing = 'linear';

    const scaleDuration = 500;
    const scaleOffset = delay / (delay + scaleDuration);
    const scaleEasing = `cubic-bezier(0.22, 1.59, 0.46, 1)`;

    const opacityExitDuration = 200;

    return {
      enter: [
        {
          keyframes: [{ opacity: 0 }, { opacity: 0, offset: opacityOffset }, { opacity: 1 }],
          easing: opacityEasing,
          duration: opacityDuration + delay,
        },
        {
          keyframes: [
            { transform: 'scale(0.9)' },
            { transform: 'scale(0.9)', offset: scaleOffset },
            { transform: 'scale(1)' },
          ],
          easing: scaleEasing,
          duration: scaleDuration + delay,
        },
      ],
      exit: {
        keyframes: [{ opacity: 1 }, { opacity: 1 }, { opacity: 0 }],
        easing: opacityEasing,
        duration: opacityExitDuration,
      },
    };
  });
